import { Factory } from 'miragejs';
// import faker from 'faker';

export default Factory.extend({
  url() {
    // TODO: Need to do something with this mock URL...
    return 'https://mock.looker-embed.com?with=all&kinds=of&params';
    // return faker.internet.url();
  },
});
